import createDebug from 'debug';
import { TenantService } from '../services/tenant/tenant.service';
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';

const debug = createDebug('tenantInterceptor');

export const tenantInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const tenantService = inject(TenantService);

  if (!req.url.startsWith('/api/')) {
    return next(req);
  }

  const tenantId = tenantService.getActiveTenantId();
  debug('tenantId', tenantId);

  if (tenantId) {
    return next(req.clone({ setHeaders: { 'X-Tenant-Id': String(tenantId) } }));
  }

  return next(req);
};
